
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { CalendarDays, CalendarCheck } from 'lucide-react';
import { useTeacherAvailability } from '@/hooks/useTeacherAvailability';
import { useTeacherAvailabilityExceptions } from '@/hooks/useTeacherAvailabilityExceptions';
import { MonthlyView } from './MonthlyView';
import { WeeklyView } from './WeeklyView';

interface AvailabilityCalendarProps {
  teacherCode: string;
}

export function AvailabilityCalendar({ teacherCode }: AvailabilityCalendarProps) {
  const [viewMode, setViewMode] = useState<'month' | 'week'>('month');
  
  const {
    weeklySchedule,
    isLoading: scheduleLoading
  } = useTeacherAvailability(teacherCode);
  
  const {
    exceptions,
    isLoading: exceptionsLoading,
    refetch: refetchExceptions
  } = useTeacherAvailabilityExceptions(teacherCode);

  if (scheduleLoading || exceptionsLoading) {
    return <div className="text-center py-4">กำลังโหลด...</div>;
  }

  const handleExceptionUpdate = () => {
    refetchExceptions();
  };

  return (
    <div className="space-y-4">
      <Tabs value={viewMode} onValueChange={value => setViewMode(value as 'month' | 'week')}>
        <TabsList className="grid w-full max-w-xs grid-cols-2">
          <TabsTrigger value="month" className="flex items-center gap-2">
            <CalendarDays size={16} />
            <span>รายเดือน</span>
          </TabsTrigger>
          <TabsTrigger value="week" className="flex items-center gap-2">
            <CalendarCheck size={16} />
            <span>รายสัปดาห์</span>
          </TabsTrigger>
        </TabsList>

        <div className="mt-4">
          <TabsContent value="month" className="space-y-4">
            <MonthlyView 
              weeklySchedule={weeklySchedule} 
              exceptions={exceptions}
              teacherCode={teacherCode}
              onExceptionUpdate={handleExceptionUpdate}
            />
          </TabsContent>

          <TabsContent value="week" className="space-y-4">
            <WeeklyView 
              weeklySchedule={weeklySchedule} 
              exceptions={exceptions}
              teacherCode={teacherCode}
              onExceptionUpdate={handleExceptionUpdate}
            />
          </TabsContent>
        </div>
      </Tabs>
    </div>
  );
}
